import { Circle, Path, Svg } from 'react-native-svg';
import { TIllustrationProps } from '@/common/components/Illustrations/types';

export const IllustrationCircles = ({
  width = 48,
  height = 48,
  className,
}: TIllustrationProps) => (
  <Svg
    width={width}
    height={height}
    fill="none"
    className={className}
    viewBox="0 0 48 48"
  >
    <Circle cx="17.45" cy="30.55" r="17.45" fill="#FFE5D8" />
    <Path
      fill="#FF8E7A"
      d="M34.47 34.47a17.46 17.46 0 1 0-20.93-20.94 17.45 17.45 0 0 1 20.93 20.93Z"
    />
  </Svg>
);
